import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import { ApiUrlService } from '@pryspace/shared/environments';
import { ApiMessageResponse, RegisterPayload } from './models';

@Injectable({ providedIn: 'root' })
export class PublicAuthService {
  private http = inject(HttpClient);
  private api = inject(ApiUrlService);

  register(payload: RegisterPayload) {
    return firstValueFrom(
      this.http.post<ApiMessageResponse>(this.api.url('v1/public/auth/register/'), payload),
    );
  }

  verifyEmail(token: string) {
    return firstValueFrom(this.http.post<ApiMessageResponse>(
      this.api.url('v1/public/auth/verify-email/'), { token },
    ));
  }

  resendVerification(email: string) {
    return firstValueFrom(this.http.post<ApiMessageResponse>(
      this.api.url('v1/public/auth/resend-verification/'), { email },
    ));
  }

  requestPasswordReset(email: string) {
    return firstValueFrom(this.http.post<ApiMessageResponse>(
      this.api.url('v1/public/auth/password-reset/request/'), { email },
    ));
  }

  confirmPasswordReset(token: string, password: string) {
    return firstValueFrom(
      this.http.post<ApiMessageResponse>(this.api.url('v1/public/auth/password-reset/confirm/'), {
        token,
        password,
      }),
    );
  }
}
